import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { ToastrService } from 'ngx-toastr';
import { ApplicationService } from 'src/app/services/http/application.service';
import { DictionaryItem, DictionaryItemGuid } from 'src/app/models/shared/dictionaryItem.model';

@Component({
  selector: 'app-application-create-edit',
  templateUrl: './application-create-edit.component.html',
  styleUrls: ['./application-create-edit.component.scss'],
  animations: [
    trigger('slideInOut', [
      state('in', style({
        transform: 'translate3d(0,0,0)'
      })),
      state('out', style({
        transform: 'translate3d(143%, 0, 0)'
      })),
      transition('in => out', animate('900ms ease-in-out')),
      transition('out => in', animate('900ms ease-in-out'))
    ]),
  ], host: {
    '(document:click)': 'handleClick($event)',
  },
})

export class ApplicationCreateEditComponent implements OnInit {
  public rumberOfRedirectUrl: number = 1;
  showShadow = false;
  @Input() animationState = 'out';
  @Output() parentComp = new EventEmitter();
  @ViewChild("f") f: any;

  public selectedApp : any = {
    loginUrls : [''],
    displayName : '',
    applicationName: '',
    id : undefined,
    url : '',
    use2FA: false,
    microsoftLoginEnabled: false
  };

  applications: DictionaryItemGuid[] = [];
  selectedBus: DictionaryItem[] = [];
  businessUnits: DictionaryItem[] = [];
  undertakings: any[] = [];
  utilities: DictionaryItem[] = [];

  constructor(private ref: ElementRef,
    private toastr: ToastrService, private applicationService: ApplicationService
  ) { }

  trackByFn(index :any, item :any) {   return index; }

  ngOnInit(): void {
    this.selectedApp = {
      loginUrls : [''],
      displayName : '',
      id : undefined,
      url : '',
      use2FA: false,
      applicationName: '',
      microsoftLoginEnabled: false
    };
  }

  incRedUrls() {
    this.selectedApp.loginUrls.push("");
  }

  deleteUrl(index: number) {
    this.selectedApp.loginUrls.splice(index, 1);
  }

  handleClick(event: any) {
    const isSliderClicked = event.target.closest('.slider');
    if (this.animationState === 'in')
      if (this.ref.nativeElement.contains(event.target) || event.target === this.ref.nativeElement) {
        if (!isSliderClicked) {
          this.changeState(2);
        }
      }
  }

  getApplication(id : any){
    this.applicationService.getByGuid(id).subscribe(response => {
      if (response.status === 200) {
        this.selectedApp = response.data
          this.selectedApp = {
            loginUrls : [''],
            displayName : response.data.displayName,
            applicationName: response.data.applicationName,
            id : response.data.id,
            url : response.data.url,
            use2FA: response.data.use2FA,
            microsoftLoginEnabled: response.data.microsoftLoginEnabled
          };
          this.selectedApp.loginUrls = [];
          response.data.loginUrls.forEach((x : String) => {
            this.selectedApp.loginUrls.push(x)
          });
      } else{
        this.toastr.error(response.message);
        this.changeState(2)
      }
    }, error => {
      this.toastr.error('An error occurred.');
      this.changeState(2)
    });
  }

  toggleShowDiv(divName: string) {
    if (divName === 'open') {
      this.animationState = 'in';
    } else if (divName === 'close')
      this.animationState = 'out';
  }

  changeState(number: Number, data?: any) {
    if (data) {
      this.getApplication(data.id);
    }
    else {
      this.selectedApp = {
        loginUrls : [''],
        displayName : '',
        applicationName: '',
        id : undefined,
        url : '',
        use2FA: false,
        microsoftLoginEnabled: false
      };
      
    }
    if (number === 1) {
      this.toggleShowDiv("open");
      this.showShadow = true;

    }
    if (number === 2) {
      this.toggleShowDiv("close");
      this.showShadow = false;
      this.f.submitted = false;
      this.selectedBus = [];
    }
  }
  
  save() {
    this.applicationService.save(this.selectedApp).subscribe(response => {
      if (response.status === 200) {
        this.toastr.success(response.message);
        this.parentComp.emit()
      } else
        this.toastr.error(response.message);
    }, error => {
      this.toastr.error('An error occurred.');
    });

    this.changeState(2)
  }

  use2FAClick() {
    this.selectedApp.use2FA = !this.selectedApp.use2FA;
  }

  useMicrosoftLogin() {
    this.selectedApp.microsoftLoginEnabled = !this.selectedApp.microsoftLoginEnabled;
  }
}



